import React from 'react';
import { useHistory } from 'react-router-dom';
import AUIButton from '@ancert/aui-button';
import AUIInputTextField from '@ancert/aui-input-text-field';
import { useNotification } from '@ancert/aui-notification-context';

import { useForm } from 'react-hook-form';
import { defaultValues, resolver } from './form';
import { postRecoverPassword } from '../../services/user.service';
import { HOMEPAGE, ROUTES } from '../../constants/routes.constants';

const RecordarContrasena = () => {
  const history = useHistory();
  const { openNotification } = useNotification();
  const { control, formState, handleSubmit } = useForm({
    defaultValues,
    resolver,
    mode: 'onSubmit',
  });

  const onSubmit = async (data) => {
    const { status, error } = await postRecoverPassword({ data });

    if (status === 200) {
      history.push(ROUTES.RECORDAR_NOTIFICACION);
      return;
    }
    const { message } = error;
    openNotification({
      title: 'Error',
      content: <div>{message || 'Ha ocurrido un error al recuperar la contraseña.'}</div>,
      type: 'error',
      centerButtons: true,
    });
  };

  return (
    <div className="c-sii-password u-mt-40">
      <h1>¿Ha olvidado su contraseña?</h1>
      <div className="c-sii-password__form">
        <p className="c-sii-password__desc">
          Introduzca su número de documento de identidad y le enviaremos un correo electrónico con una contraseña
          temporal.
        </p>
        <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
          <div className="o-grid">
            <div className="o-grid__row">
              <div className="o-grid__col-12">
                <AUIInputTextField
                  required
                  name="user"
                  label="Documento de identidad"
                  controlRef={control}
                  errors={formState.errors}
                />
              </div>
            </div>
          </div>
          <div className="c-sii-password__buttons">
            <AUIButton
              className="c-sii-password__btn"
              label="Actualizar contraseña"
              mode="secondary"
              size="lg"
              type="submit"
            />
            <a className="sii-link" href={`${HOMEPAGE}${ROUTES.HOME}`}>
              Volver
            </a>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RecordarContrasena;
